import React from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import { salesareaTypes as types } from "../../variables/app";

function SalesareaTypeFilter(props) {
  const { classes } = props;

  const salesareaTypes = [
    {
      value: "0",
      label: "All Types",
    },
    ...types,
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("salesarea_type", null);
            break;
          case "NULL":
            props.setFilter("salesarea_type", { field: "salesarea_type", operator: null, value: null });
            break;
          default:
            props.setFilter("salesarea_type", { field: "salesarea_type", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.salesarea_type?.value && props.salesarea_type?.value != "0" ? "#ff9800" : null }}
      value={props.salesarea_type?.value ? props.salesarea_type.value : props.salesarea_type == null ? "0" : "NULL"}
    >
      {salesareaTypes.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["salesarea_type"]: state.filtersV2["salesarea_type"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SalesareaTypeFilter, productenStyle));
